// extracted by mini-css-extract-plugin
export default {"breakdowntitle":"Bn","result_page":"Cn","what_are_calories":"En","title":"Fn","copy":"Gn","chart":"Hn","to_reach":"In","title_wrapper":"Jn","rhode_percent":"Kn","what_are_macro":"Ln","text":"Mn","img":"Nn","macros_wrapper":"On","macros":"Pn","macro_item":"Qn","value":"Rn","note":"Sn","btn":"Tn","carbo_item":"Un","faq":"Vn","faq_items":"Wn"};
    if(module.hot) {
      // 1721922359081
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  